import { useEffect } from "react";

import {
  Accordion,
  AccordionActions,
  AccordionSummary,
  AccordionDetails,
  Box,
  Button,
  Stack,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import useLocalization from "../../hooks/useLocalization";

import InfoBox from "../layout/InfoBox";
import AvailabilityDisplay from "./AvailabilityDisplay";
import ControlledByDisplay from "./ControlledByDisplay";
import VisibilityDisplay from "./VisibilityDisplay";

const SurveyPage = ({
  surveyId,
  page,
  pageIndex,
  expanded,
  onExpand,
  onEdit,
}) => {
  const theme = useTheme();

  const { getLabel, getMessage } = useLocalization();

  const handleEdit = () => {
    onEdit(pageIndex);
  };

  if (!page) return null;

  return (
    <Accordion
      onChange={(e, isExpanded) => onExpand(pageIndex, isExpanded)}
      expanded={expanded}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          backgroundColor: expanded
            ? theme.palette.primary.dark
            : theme.palette.primary.light,
        }}
      >
        <Box sx={{ width: "300px", whiteSpace: "wrap" }}>{page.name}</Box>
      </AccordionSummary>
      <AccordionDetails sx={{ border: "1px solid #ccc" }}>
        <Stack
          spacing={1}
          width="300px"
        >
          <InfoBox label={getLabel("name_fr")}>
            {page.name_fr ? page.name_fr : getMessage("notSet")}
          </InfoBox>
          <InfoBox label={getLabel("active")}>
            {page.isActive ? "True" : "False"}
          </InfoBox>
          <InfoBox label={getLabel("availability")}>
            <AvailabilityDisplay
              value={page.availability}
              emptyMessage={getMessage("basedOnSurvey")}
            />
          </InfoBox>
          <InfoBox label={getLabel("controlledBy")}>
            <ControlledByDisplay
              value={page.controlledBy}
              pageIndex={pageIndex}
              surveyId={surveyId}
            />
          </InfoBox>
          <InfoBox label={getLabel("visibility")}>
            <VisibilityDisplay value={page.visibility} />
          </InfoBox>
        </Stack>
      </AccordionDetails>

      <AccordionActions>
        <Button
          onClick={handleEdit}
          variant="contained"
          size="small"
        >
          {getLabel("edit")}
        </Button>
      </AccordionActions>
    </Accordion>
  );
};

export default SurveyPage;
